<template>
  <transition name="fade" mode="out-in">
    <loader-with-message v-if="isServicesDataLoading"
                         :has-error="servicesDataFetchError"
                         @retry="getReconnectionData"
                         class="connected-services"/>
    <div v-else class="connected-services">
      <transition name="fade" mode="out-in">
        <section :key="'service-overview'" class="connected-services"
                 v-if="!passwordStep && currentStep === 'service-overview'">
          <template v-if="$props.deleteAccount">
            <template class="connected" v-if="connectedServices.length">
              <h3 class="service-title acc-mng">{{ $t('servicesManagementPopup.connectedServices') }}</h3>
              <div class="services-container">
                <account-card v-for="(service, index) in connectedServices"
                              :key="'conService'+index"
                              class="service-card delete"
                              :title="service.title"
                              :name="`${service.firstName} ${service.lastName ? service.lastName : ''}`"
                              :label="service.description"
                              :type="service.type">
                  <base-button class="transparent" size="small"
                               @click="deleteUserAccount(service.customerId, service.title)">
                    {{ $t('servicesAccountManagement.deleteAccount') }}
                  </base-button>
                </account-card>
              </div>
              <base-button variant="primary" class="wide-button account-mng-btn" @click="chooseService">
                {{ $t('servicesManagementPopup.addServiceButton') }}
              </base-button>
            </template>
            <template class="recognized" v-if="recognizedServices.length">
              <h3 class="service-title acc-mng">{{ $t('servicesManagementPopup.foundServices') }}</h3>
              <div class="services-container">
                <account-card v-for="(service, index) in recognizedServices"
                              :key="'recService'+index"
                              class="service-card overflowed-card"
                              :class="{'validation': service.otpCodeSent || service.enterCustomerId}"
                              :validation-mode="service.otpCodeSent || service.enterCustomerId"
                              :title="service.title"
                              :name="`${service.firstName} ${service.lastName ? service.lastName : ''}`"
                              :label="service.description"
                              :type="service.type">
                  <transition name="slide" mode="out-in">
                    <div
                      v-if="service.otpCodeSent && (service.type === 'MOBILE_POSTPAID' || service.type === 'MOBILE_PREPAID')">
                      <h4 class="validation-title">
                        {{ $t('services.validationCardTitle') }}
                      </h4>
                      <div class="card-description">
                        <p class="label-text">
                          <span v-html="$t('services.mobileValidationLabel', {userPhoneNumber: service.title})"></span>
                          <a href="#"
                             class="btn-send-again"
                             @click.prevent="sendOTPCode(index, service.subscriberIdentity, service.customerId, true)">{{
                              $t('registration.sendCodeAgain')
                            }}.
                          </a>
                        </p>
                      </div>
                      <validation-observer :ref="'otpObserverMobile'+index"
                                           tag="form"
                                           v-autofocus
                                           @submit.prevent="verifyOtpCode(index, service.otpCode, service.subscriberIdentity, service.customerId)">
                        <div class="input-validation-wrapper">
                          <base-v-input v-model.trim="service.otpCode"
                                        id="otpCodeMyAccount"
                                        container-class="validation-nowrap"
                                        name="otpCode"
                                        rules="required|otpCode"
                                        :submitted="service.submitted"
                                        :label="$t('registration.codeLabel')"
                                        :vid="'otpCode'+index"
                                        maxlength="20"/>
                          <base-button variant="primary"
                                       size="small"
                                       class="validation-button"
                                       :disabled="!service.otpCode || !service.otpCode.length"
                                       :loading="service.dataLoading"
                                       type="submit">
                            {{ $t('services.connectContract') }}
                          </base-button>
                        </div>
                      </validation-observer>
                    </div>
                    <base-button v-else
                                 variant="primary"
                                 size="small"
                                 @click="checkReconnectionForService(index, service.subscriberIdentity, service.type)">
                      {{ $t('services.connectContract') }}
                    </base-button>
                  </transition>
                </account-card>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-if="recognizedServices.length">
              <h3 class="service-title">{{ $t('servicesManagementPopup.foundServices') }}</h3>
              <div class="services-container">
                <account-card v-for="(service, index) in recognizedServices"
                              :key="'recService'+index"
                              class="service-card overflowed-card"
                              :class="{'validation': service.otpCodeSent || service.enterCustomerId}"
                              :title="service.title"
                              :name="`${service.firstName} ${service.lastName ? service.lastName : ''}`"
                              :label="service.description"
                              :validation-mode="service.otpCodeSent || service.enterCustomerId"
                              :type="service.type">
                  <transition name="slide" mode="out-in">
                    <div
                      v-if="service.otpCodeSent && (service.type === 'MOBILE_POSTPAID' || service.type === 'MOBILE_PREPAID')">
                      <h4 class="validation-title">
                        {{ $t('services.validationCardTitle') }}
                      </h4>
                      <div class="card-description">
                        <p class="label-text">
                          <span v-html="$t('services.mobileValidationLabel', {userPhoneNumber: service.title})"></span>
                          <a href="#"
                             class="btn-send-again"
                             @click.prevent="sendOTPCode(index, service.subscriberIdentity, service.customerId, true)">{{
                              $t('registration.sendCodeAgain')
                            }}.
                          </a>
                        </p>
                      </div>
                      <validation-observer :ref="'otpObserverMobile'+index"
                                           tag="form"
                                           v-autofocus
                                           @submit.prevent="verifyOtpCode(index, service.otpCode, service.subscriberIdentity, service.customerId)">
                        <div class="input-validation-wrapper">
                          <base-v-input v-model.trim="service.otpCode"
                                        id="otpCode"
                                        container-class="validation-nowrap"
                                        name="otpCode"
                                        rules="required|otpCode"
                                        :submitted="service.submitted"
                                        :label="$t('registration.codeLabel')"
                                        :vid="'otpCode'+index"
                                        maxlength="20"/>
                          <base-button variant="primary"
                                       size="small"
                                       class="validation-button"
                                       :disabled="!service.otpCode || !service.otpCode.length"
                                       :loading="service.dataLoading"
                                       type="submit">
                            {{ $t('services.connectContract') }}
                          </base-button>
                        </div>
                      </validation-observer>
                    </div>
                    <base-button v-else
                                 variant="primary"
                                 size="small"
                                 @click="checkReconnectionForService(index, service.subscriberIdentity, service.type)">
                      {{ $t('services.connectContract') }}
                    </base-button>
                  </transition>
                </account-card>
              </div>
            </template>
            <template class="connected" v-if="connectedServices.length">
              <h3 class="service-title">{{ $t('servicesManagementPopup.connectedServices') }}</h3>
              <div class="services-container">
                <account-card v-for="(service, index) in connectedServices"
                              :key="'conService'+index"
                              class="service-card"
                              :title="service.title"
                              :name="`${service.firstName} ${service.lastName ? service.lastName : ''}`"
                              :label="service.description"
                              connected
                              :type="service.type"/>
              </div>
            </template>
          </template>
          <modal
            size="lg"
            :visible="modalVisible"
            @modal-close="modalVisible = false"
            :close-button-visible="false">
            <div class="delete-header">
              <img src="/assets/images/delete-warning.svg" alt="" class="warning-img">
              <h2>{{ $t('servicesAccountManagement.deleteModal.title') }}</h2>
            </div>
            <div class="delete-body">
              <p class="description">{{ $t('servicesAccountManagement.deleteModal.description') }}</p>
              <div class="button-container">
                <base-button variant="primary" @click="confirmDelete">
                  {{ $t('servicesAccountManagement.deleteModal.confirmDelete') }}
                </base-button>
                <button class="cancel-btn" @click="cancelDelete">{{
                    $t('servicesAccountManagement.deleteModal.cancel')
                  }}
                </button>
              </div>
            </div>
          </modal>
        </section>
        <section class="component-holder" v-if="currentStep === 'choose-service'" :key="'step2'">
          <connect-new-service :connection-data="getReconnectionData" ref="newServiceComp" @cancel-add="backToStepOne"/>
        </section>
        <section class="connected-services password-entry-step" v-if="passwordStep" :key="'password-entry'">
          <h2 class="title">{{ $t('servicesManagementPopup.addContract') }}</h2>
          <template v-if="reconnectionType ===  'mobile'">
            <h3 class="subtitle">{{ $t('servicesManagementPopup.mobileServiceTitle') }}</h3>
            <p class="description"
               v-html="$t('servicesManagementPopup.addMobileServiceDescription1', { phoneNumber: userPhoneNumber, email: userEmail})"></p>
          </template>
          <template v-else>
            <h3 class="subtitle">{{ $t('servicesManagementPopup.cableServiceTitle') }}</h3>
            <p class="description"
               v-html="$t('servicesManagementPopup.addCableServiceDescription1', { email: userEmail})"></p>
          </template>
          <p class="description" v-html="$t('servicesManagementPopup.addServiceDescription2', {email: userEmail})"></p>
          <validation-observer ref="passwordObs"
                               tag="form"
                               class="service-form"
                               @submit.prevent="submitRegistrationRequestWithPassword">
            <base-v-input v-model.trim="userPassword"
                          id="password"
                          name="password"
                          rules="required"
                          container-class="text-bold"
                          :submitted="passwordSubmitted"
                          :label="$t('registration.passwordLabel')"
                          revealPassword
                          variant="white"
                          type="password"
                          maxlength="20"
                          vid="password"
                          ref="password"/>
            <div class="action-buttons">
              <a href="#" class="back-link" @click.prevent="cancelAddingService">{{ $t('common.cancel') }}</a>
              <base-button variant="primary" type="submit" :disabled="!userPassword.length || dataLoading"
                           :loading="dataLoading">{{ $t('common.continue') }}
              </base-button>
            </div>
          </validation-observer>
        </section>
      </transition>
    </div>
  </transition>
</template>

<script>
import AccountCard from '@/components/services/connectServices/account-card'
import Modal from '@/components/common/modal/modal'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import ConnectNewService from '@/components/services/connectServices/connect-new-service'
import { lsRemove } from '@/utils/localStorageController'
import LoaderWithMessage from '@/components/common/loader-with-message'

const steps = {
  serviceOverview: 'service-overview',
  chooseService: 'choose-service'
}

export default {
  name: 'connected-services',
  components: { LoaderWithMessage, AccountCard, Modal, ConnectNewService },
  data () {
    return {
      connectFixAccountSubmitted: false,
      connectMobileAccountSubmitted: false,
      buttonDisabled: false,
      userCustomerId: '',
      customerId: null,
      dataLoading: false,
      connectedServices: [],
      recognizedServices: [],
      modalVisible: false,
      customerIds: [],
      selectedId: '',
      userPassword: '',
      passwordSubmitted: false,
      userPhoneNumber: '',
      userEmail: '',
      userOtpCode: '',
      reconnectionType: 'mobile',
      showValidationForCustomers: [],
      passwordStep: false,
      selectedAccountIndex: -1,
      currentStep: '',
      isServicesDataLoading: false,
      servicesDataFetchError: false
    }
  },
  mixins: [errorMessageHandler],
  props: {
    deleteAccount: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    connectFixAccountFilled () {
      return !!this.userCustomerId
    },
    connectMobileAccountFilled () {
      return !!this.userOtpCode
    }
  },
  methods: {
    chooseService () {
      this.currentStep = 'choose-service'
      this.$emit('show-password')
    },
    backToStepOne (refresh = false) {
      this.$emit('cancel-add')
      this.currentStep = steps.serviceOverview
      if (refresh) {
        // this.$refs.connectedServices.getReconnectionData()
        this.$emit('refresh-side-nav')
      }
    },
    getReconnectionData (count = 0) {
      this.isServicesDataLoading = true
      this.servicesDataFetchError = false
      this.connectedServices = []
      this.recognizedServices = []
      this.$apiRequest.get('user/service/connection/info')
        .then(response => {
          this.connectedServices = response.data.connectedServices || []
          this.recognizedServices = response.data.recognizedServices || []
          this.customerIds = this.connectedServices.map(service => service.customerId)
          const getId = this.recognizedServices.map(service => service.customerId)
          this.customerId = getId.toString()
          this.$emit('id-fetched', this.customerIds)
          this.title = ''
          this.isServicesDataLoading = false
        })
        .catch(e => {
          if (e.response.data && e.response.data.errors && e.response.data.errors.length && e.response.data.errors[0].type === 'MtmCustomerInfoUpdateNotCompleteError') {
            setTimeout(() => {
              if (count < 5) {
                this.getReconnectionData(count++)
              } else {
                this.servicesDataFetchError = true
              }
            }, 1000)
          } else {
            this.servicesDataFetchError = true
          }
          // this.handleErrorMessage(e.response.data)
        })
    },
    deleteUserAccount (customerId, title) {
      this.modalVisible = true
      this.selectedId = customerId
      this.title = title
    },
    confirmDelete () {
      this.$apiRequest.delete(`user/service/disconnect?customerId=${this.selectedId}`)
        .then(response => {
          if (response.status === 200) {
            this.modalVisible = false
            this.toast('success', {
              title: this.$t('toastMessages.successToastTitle'),
              message: this.$t('toastMessages.deletedAccountMessage', { title: this.title })
            })
            lsRemove('sc_menu_services')
            setTimeout(() => {
              this.getReconnectionData()
            }, 150)
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.customerId = ''
          this.title = ''
        })
    },
    cancelDelete () {
      this.modalVisible = false
      this.customerId = ''
      this.title = ''
    },
    resetRecognizedServicesData () {
      // ensure that user can start adding only one service
      this.userCustomerId = ''
      this.recognizedServices.forEach(service => {
        if (service.dataHelper !== undefined) {
          this.$delete(service, 'dataHelper')
        }
        if (service.reconnectionData !== undefined) {
          this.$delete(service, 'reconnectionData')
        }
        if (service.otpCodeSent !== undefined) {
          this.$delete(service, 'otpCodeSent')
        }
        if (service.enterCustomerId !== undefined) {
          this.$delete(service, 'enterCustomerId')
        }
        if (service.otpCode !== undefined) {
          // this.$delete(service, 'otpCode')
          service.otpCode = ''
        }
      })
    },
    checkReconnectionForService (index, phoneNumber, type) {
      // reset data
      this.resetRecognizedServicesData()
      this.$emit('show-password')
      this.reconnectionType = 'mobile'
      this.selectedAccountIndex = -1
      const mobileTypes = ['MOBILE_POSTPAID', 'MOBILE_PREPAID']
      if (mobileTypes.includes(type)) {
        this.checkMobilePhone(index, phoneNumber)
      } else {
        this.userCustomerId = this.recognizedServices[index].customerId
        this.checkReconnectionCable(index)
      }
    },
    checkMobilePhone (index, phoneNumber) {
      this.userEmail = this.recognizedServices[index].email
      this.sendOTPCode(index, phoneNumber, this.recognizedServices[index].customerId)
    },
    sendOTPCode (index, phoneNumber, customerId) {
      // disable button
      this.$set(this.recognizedServices[index], 'dataLoading', true)

      const dataToSend = {
        msisdn: phoneNumber,
        platform: 'WEB',
        otpRequestType: 'SERVICE_CONNECT',
        customerId: customerId
      }

      this.$apiRequest.post('user/sendotpcode', dataToSend)
        .then((response) => {
          this.$set(this.recognizedServices[index], 'otpCodeSent', true)
          this.toast('success', {
            message: this.$t('toastMessages.otpCodeSent')
          })
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.$set(this.recognizedServices[index], 'dataLoading', false)
        })
    },
    async verifyOtpCode (index, otpCode, phoneNumber, customerId) {
      const observerRef = this.$refs[`otpObserverMobile${index}`].length ? this.$refs[`otpObserverMobile${index}`][0] : this.$refs[`otpObserverMobile${index}`]
      const isFormValid = await observerRef.validate()
      this.$set(this.recognizedServices[index], 'submitted', true)

      if (isFormValid) {
        const dataToSend = {
          msisdn: phoneNumber,
          otp: otpCode,
          otpRequestType: 'SERVICE_CONNECT',
          customerId: customerId
        }

        this.$apiRequest.post('user/verifyotpcode', dataToSend)
          .then((response) => {
            const dataToEmit = {
              phoneNumber: response.data.msisdn,
              otpCode: response.data.code,
              type: 'mobile',
              userId: response.data.customerId
            }
            this.selectedAccountIndex = index
            this.$set(this.recognizedServices[index], 'dataHelper', dataToEmit)
            if (this.recognizedServices[index].registered) {
              this.passwordStep = true
              this.$emit('step-change')
            } else {
              this.sendMobileRegistrationRequest()
            }
          })
          .catch(e => {
            if (e.response.data.errors && e.response.data.errors.length && e.response.data.errors[0].message) {
              observerRef.setErrors({
                [`otpCode${index}`]: e.response.data.errors[0].message
              })
            } else {
              this.toast('error', {
                message: this.$t('errors.serverError')
              })
            }
          })
      } else {
        this.$set(this.recognizedServices[index], 'dataLoading', false)
      }
    },
    sendMobileRegistrationRequest (password) {
      const dataToSend = {
        msisdn: this.recognizedServices[this.selectedAccountIndex].dataHelper.phoneNumber,
        otpRequestCode: this.recognizedServices[this.selectedAccountIndex].dataHelper.otpCode,
        customerId: this.recognizedServices[this.selectedAccountIndex].dataHelper.userId
      }

      if (password) {
        dataToSend.login = this.recognizedServices[this.selectedAccountIndex].email
        dataToSend.password = password
      }

      this.$apiRequest.post('user/service/connection/mobile', dataToSend)
        .then(response => {
          this.toast('success', {
            title: this.$t('servicesManagementPopup.successMessage.title'),
            message: this.$t('servicesManagementPopup.successMessage.message')
          })
          this.cancelAddingService(true)
          lsRemove('sc_menu_services')
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    async submitRegistrationRequestWithPassword () {
      this.passwordSubmitted = true

      const fieldValid = await this.$refs.passwordObs.validate()

      if (fieldValid) {
        this.dataLoading = true
        if (this.reconnectionType === 'mobile') {
          this.sendMobileRegistrationRequest(this.userPassword)
        } else {
          this.sendCableRegistrationRequest(this.userPassword)
        }
      } else {
        this.dataLoading = false
      }
    },
    checkReconnectionCable (index) {
      this.selectedAccountIndex = index

      if (this.recognizedServices[index].registered) {
        const dataToSave = {
          email: this.recognizedServices[index].email,
          customerId: this.recognizedServices[index].customerId
        }
        this.reconnectionType = 'fix'
        this.$set(this.recognizedServices[index], 'dataHelper', dataToSave)
        this.userEmail = this.recognizedServices[index].email
        // go to password entry
        this.passwordStep = true
        this.$emit('step-change')
      } else {
        this.sendCableRegistrationRequest()
      }
    },
    sendCableRegistrationRequest (password) {
      const dataToSend = {
        customerId: this.userCustomerId
      }

      if (password) {
        dataToSend.login = this.recognizedServices[this.selectedAccountIndex].dataHelper.email
        dataToSend.password = password
      }

      this.$apiRequest.post('user/service/connection/fixed', dataToSend)
        .then(response => {
          this.toast('success', {
            title: this.$t('servicesManagementPopup.successMessage.title'),
            message: this.$t('servicesManagementPopup.successMessage.message')
          })

          this.cancelAddingService(true)
          lsRemove('sc_menu_services')
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    cancelAddingService (refresh = false) {
      this.passwordStep = false
      if (refresh) {
        this.resetRecognizedServicesData()
        this.getReconnectionData()
      }
      setTimeout(() => {
        this.$emit('cancel-add', refresh)
      }, 150)
    }
  },
  mounted () {
    this.resetRecognizedServicesData()
    this.getReconnectionData()
    this.currentStep = steps.serviceOverview
  }
}
</script>

<style lang="scss">

.connected-services {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;

  .service-title {
    font-size: 1.6rem;
    font-weight: 600;
    margin-top: 3.2rem;
    margin-bottom: 1.6rem;
    padding-bottom: .8rem;
    border-bottom: 1px solid $border;

    &.acc-mng {
      border-bottom: none;
    }
  }

  .account-mng-btn {
    margin-top: 24px;
    width: 100%;
    @media (map_get($breakpoints, sm)) {
      width: 20rem;
    }
  }

  .services-container {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.4rem;

    .service-card {
      flex-basis: 100%;

      @media (map_get($breakpoints, sm)) {
        flex-basis: calc(50% - .8rem);
        max-width: calc(50% - 0.8rem);
      }

      &.validation {
        p {
          margin-top: 8px;
          color: $light-black;
          font-size: 12px;
        }

        .validation-title {
          text-transform: uppercase;
          margin-bottom: 0.5rem;
        }

        .validated-input .error-msg {
          top: 66px;
        }

        .card-description {
          display: flex;

          .label-text {
            color: $light-black;
            font-size: 12px;
            margin-top: 0;
            margin-bottom: .5rem;

            span {
              margin-right: .5rem;
            }

            .btn-send-again {
              text-decoration: underline;
            }
          }

          button {
            color: $primary;
            font-size: 12px;
            text-decoration: underline;
          }
        }
      }
    }

    .overflowed-card {
      min-height: 13rem;
      overflow: hidden;

      @media (map_get($breakpoints, sm)) {
        max-height: 17rem;
      }

      @media (map_get($breakpoints, md)) {
        height: 14.6rem;
      }
    }
  }
}

.delete-header {
  text-align: center;

  img {
    max-width: 112px;
    width: 100%;
    height: auto;
    display: block;
    margin: 0.8rem auto;
  }

  h2 {
    font-size: 3.2rem;
    color: $text;
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
    font-weight: normal;
  }
}

.delete-body {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;

  .description {
    margin: 4rem 0;
  }

  .button-container {
    text-align: center;
    margin-top: 4rem;
  }

  .cancel-btn {
    border: none;
    color: $primary;
    padding-left: 4rem;
    font-weight: 600;
    font-size: 16px;
  }
}

.input-validation-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .validated-input {
    padding-bottom: 0;

    .base-input .input-container input {
      height: 4rem;
      padding: 9px 16px;
    }

    input {
      height: 4rem;
      max-width: 170px;
      padding-bottom: 0;
    }
  }

  .validation-button {
    margin-left: 0.5rem;
    min-width: auto;

    @media (map_get($breakpoints, sm)) {
      min-width: 180px;
    }
  }
}

.password-entry-step {
  .title {
    font-size: 2.4rem;
    font-weight: 600;
    margin-top: 1.6rem;
    margin-bottom: 4.8rem;
  }

  .subtitle {
    font-size: 1.6rem;
    font-weight: 600;
    text-transform: uppercase;
    padding-bottom: 0.8rem;
    margin-bottom: 3.2rem;
    border-bottom: 1px solid $border;
  }

  .description {
    font-size: 1.6rem;
    line-height: 1.75;
    margin-bottom: 2.4rem;
    width: 100%;
    max-width: 560px;
  }

  .service-form {
    width: 100%;
    max-width: 320px;
    padding: 0;
    margin: 0;
    background-color: transparent;

    .action-buttons {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (map_get($breakpoints, sm)) {
        flex-direction: row;
        justify-content: flex-end;
      }

      a.back-link {
        display: block;
        margin-top: 2.4rem;
        padding: 0 3rem;
        margin-right: 1rem;
        font-weight: 600;
        text-decoration: none;

        @media (map_get($breakpoints, sm)) {
          margin-top: 0;
          width: auto;
        }
      }
    }
  }

  &.password-step {
    .title {
      margin-bottom: 5.6rem;
    }
  }
}

</style>
